module.exports = "<!-- <div class=\"columns\">\n\t<div class=\"column\" app-submenu [menus]=\"menus\">\n\t</div>\n</div> -->\n<router-outlet></router-outlet>\n"